import { httpClient } from "@bw/shared/api";
import type { Schema } from "@bw/shared/types/generated";

/**
 * Neutral generated-contract seam for the platform-admin capability consumed
 * by Settings and Users. Presentation, authority reconciliation, and mutation
 * lifecycle ownership remain in those consumers.
 */

export type PlatformAdminAccessCandidate =
  Schema["PlatformAdminAccessCandidate"];
export type PlatformAdminAccessCandidatesResponse =
  Schema["PlatformAdminAccessCandidatesResponse"];
export type PlatformAdminAccessRosterResponse =
  Schema["PlatformAdminAccessRosterResponse"];
export type PlatformAdminGrantResponse = Schema["PlatformAdminGrantResponse"];
export type InviteAdminRequest = Schema["InviteAdminRequest"];
export type RevokeAdminRequest = Schema["RevokeAdminRequest"];
export type PlatformAdminAccessState =
  PlatformAdminAccessCandidate["access_state"];

export async function getPlatformAdminRoster(
  limit = 50,
): Promise<PlatformAdminAccessRosterResponse> {
  const search = new URLSearchParams({ limit: String(limit) });
  return httpClient.get<PlatformAdminAccessRosterResponse>(
    `/platform/admin-access/roster?${search.toString()}`,
  );
}

export async function searchPlatformAdminCandidates(
  query: string,
  limit = 8,
): Promise<PlatformAdminAccessCandidatesResponse> {
  const search = new URLSearchParams({ query, limit: String(limit) });
  return httpClient.get<PlatformAdminAccessCandidatesResponse>(
    `/platform/admin-access/candidates?${search.toString()}`,
  );
}

export async function invitePlatformAdmin(
  email: string,
): Promise<PlatformAdminGrantResponse> {
  const request = Object.freeze({ email }) satisfies InviteAdminRequest;
  return httpClient.post<PlatformAdminGrantResponse>(
    "/platform/invite-admin",
    request,
  );
}

export async function revokePlatformAdmin(email: string): Promise<void> {
  const request = Object.freeze({ email }) satisfies RevokeAdminRequest;
  await httpClient.post<void>("/platform/admin-access/revoke", request);
}
